import { motion } from "framer-motion";
import { Reveal, SectionHeading, EASE } from "@/components/Reveal";


export default function Concept() {
  return (
    <section id="babylon" className="relative py-32 lg:py-48" data-testid="concept-section">
      <div className="max-w-7xl mx-auto px-5 sm:px-8 grid lg:grid-cols-12 gap-14 lg:gap-20 items-center">
        <div className="lg:col-span-7">
          <SectionHeading
            eyebrow="Le concept"
            title={
              <>
                Vous recherchez une montre.
                <br />
                <span className="italic text-gold">Nous activons nos connexions.</span>
              </>
            }
          />
          <Reveal delay={0.2} className="mt-9 space-y-6 text-stone2 text-base sm:text-lg leading-relaxed max-w-xl">
            <p>
              Inutile de parcourir des dizaines de sites ou de contacter différents vendeurs.
              Indiquez simplement à BABYLON le modèle, la référence, la configuration — ou même
              simplement le style de montre que vous recherchez.
            </p>
            <p>
              Nous nous chargeons ensuite de rechercher la meilleure opportunité disponible,
              grâce à un réseau de fournisseurs et de professionnels présent sur différents marchés.
            </p>
          </Reveal>
          <Reveal delay={0.35}>
            <p className="mt-12 font-display italic text-3xl sm:text-4xl text-ivory" data-testid="concept-slogan">
              « Vous recherchez. <span className="text-gold">Nous trouvons.</span> »
            </p>
          </Reveal>
        </div>

        <div className="lg:col-span-5">
          <Reveal delay={0.25}>
            <div className="relative">
              <div className="absolute -inset-3 border border-gold/15 -translate-x-3 translate-y-3 pointer-events-none" />
              <div className="overflow-hidden gold-frame">
                <motion.video
                  src="/videos/omega-concept.mp4"
                  poster="/images/omega-poster.jpg"
                  autoPlay
                  muted
                  loop
                  playsInline
                  className="w-full h-[340px] sm:h-[440px] object-cover"
                  whileHover={{ scale: 1.04 }}
                  transition={{ duration: 1.2, ease: EASE }}
                  data-testid="concept-video"
                />
              </div>
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
